import { ErrorSpan } from "components/elements/ErrorSpan";

export const ErrorDetails = ({ error }: { error: string }) => {
  return (
    <div style={{ maxHeight: "4rem", maxWidth: "100%", textAlign: "center", overflowX: "hidden", overflowY: "auto" }}>
      <ErrorSpan>ERROR: {error}</ErrorSpan>
    </div>
  );
};
